import { useContext, useState, useMemo } from "react";
import HeaderAdmin from "../../components/HeaderAdmin/HeaderAdmin";
import "./styles.css";
import Solicitacoes from "./components/Solicitações/Solicitacoes";
import Usuarios from "./components/Usuários/Usuarios";
import Dash from "./components/DashUpload/DashUpload"; // Componente para "Apagar relatórios"
import Ranking from "./components/Ranking/Ranking";
import TaxaPlataforma from "./components/TaxaPlataforma/TaxaPlataforma";
import { Context } from "../../hooks/useAuthContext";
import { Nav, NavItem, NavLink } from "reactstrap";
import classNames from "classnames";
import RelatorioTabs from "./components/Relatorios/RelatorioTabs";
import Mensagens from "./components/Mensagens/Mensagens";
import Alertas from "./components/Alertas/Alertas";

function Admin() {
  const { userData } = useContext(Context);
  const tipoConta = userData?.tipoConta;

  const podeVerSolicitacoes = useMemo(() => 
    ['administrador', 'coordenacao', 'automacao'].includes(tipoConta), 
    [tipoConta]
  );
  const podeVerUsuarios = useMemo(() => 
    ['administrador', 'coordenacao', 'automacao', "financeiro"].includes(tipoConta), 
    [tipoConta]
  );
  const podeVerApagarRelatorios = useMemo(() => 
    tipoConta === 'administrador', 
    [tipoConta]
  );

  const podeVerRelatorios = useMemo(() => 
    ['administrador', 'coordenacao', 'gestor'].includes(tipoConta), 
    [tipoConta]
  );

  const podeVerRanking = useMemo(() => 
    ['administrador', 'coordenacao'].includes(tipoConta), 
    [tipoConta]
  );
  const podeVerTaxa = useMemo(() => 
    ['administrador', 'financeiro'].includes(tipoConta), 
    [tipoConta]
  );

    const podeVerMensagens = useMemo(() => 
    ['administrador', 'coordenacao', 'automacao'].includes(tipoConta), 
    [tipoConta]
  );

  const poderVerAlertas = useMemo(() => 
    ['administrador', 'coordenacao', 'automacao'].includes(tipoConta), 
    [tipoConta]
  );
  
  const abasDisponiveis = useMemo(() => {
    const abas = [];
    if (podeVerSolicitacoes) abas.push("Solicitações");
    if (podeVerUsuarios) abas.push("Usuários");
    if (podeVerApagarRelatorios) abas.push("Apagar relatórios");
    if (podeVerRelatorios) abas.push("Relatórios");
    if (podeVerRanking) abas.push("Ranking");
    if (podeVerTaxa) abas.push("Taxa");
    if (podeVerMensagens) abas.push("Mensagens");
    if (poderVerAlertas) abas.push("Alertas");
    return abas;
  }, [podeVerSolicitacoes, podeVerUsuarios, podeVerApagarRelatorios, podeVerRanking, podeVerTaxa, podeVerMensagens, poderVerAlertas]);

  const [tab, setTab] = useState(abasDisponiveis[0] || "");

  const getTabClassName = (tabName) => {
    return classNames('admin-page__btn-tab', {
      'admin-page__btn-tab--selected': tab === tabName
    });
  };
  
  return (
    <div>
      <HeaderAdmin />

      {abasDisponiveis.length === 0 ? 
        <div className="admin-page">
          <div className="p-5 text-center">
            <h4>Você não tem permissão para acessar nenhuma área.</h4>
          </div>
        </div>
      : 
        <div className="admin-page">
          <div className="admin-page__tabs">
          <Nav tabs className="flex-wrap border-bottom-0">
            {podeVerSolicitacoes && (
              <NavItem className="me-3">
                <NavLink
                  className={getTabClassName("Solicitações")}
                  onClick={() => setTab("Solicitações")}
                >
                  Solicitações
                </NavLink>
              </NavItem>
            )}

            {podeVerUsuarios && (
              <NavItem className="me-3">
                <NavLink
                  className={getTabClassName("Usuários")}
                  onClick={() => setTab("Usuários")}
                >
                  Usuários
                </NavLink>
              </NavItem>
            )}

            {podeVerApagarRelatorios && (
              <NavItem className="me-3">
                <NavLink
                  className={getTabClassName("Apagar relatórios")}
                  onClick={() => setTab("Apagar relatórios")}
                >
                  Apagar relatórios
                </NavLink>
              </NavItem>
            )}


            {podeVerRelatorios && (
              <NavItem className="me-3">
                <NavLink
                  className={getTabClassName("Relatórios")}
                  onClick={() => setTab("Relatórios")}
                >
                  Relatórios
                </NavLink>
              </NavItem>
            )}

            {podeVerRanking && (
              <NavItem className="me-3">
                <NavLink
                  className={getTabClassName("Ranking")}
                  onClick={() => setTab("Ranking")}
                >
                  Ranking
                </NavLink>
              </NavItem>
            )}

            {podeVerTaxa && (
              <NavItem className="me-3">
                <NavLink
                  className={getTabClassName("Taxa")}
                  onClick={() => setTab("Taxa")}
                >
                  Taxa
                </NavLink>
              </NavItem>
            )}

            {podeVerMensagens && (
              <NavItem className="me-3">
                <NavLink
                  className={getTabClassName("Mensagens")}
                  onClick={() => setTab("Mensagens")}
                >
                  Mensagens
                </NavLink>
              </NavItem>
            )}

            {poderVerAlertas && (
              <NavItem className="me-3">
                <NavLink
                  className={getTabClassName("Alertas")}
                  onClick={() => setTab("Alertas")}
                >
                  Alertas
                </NavLink>
              </NavItem>
            )}
          </Nav>
          </div>
          <hr />
          <div className="miniWrapper">
            <div className="areaForm">
              {tab === "Solicitações" && <Solicitacoes />}
              {tab === "Usuários" && <Usuarios />}
              {tab === "Apagar relatórios" && <Dash />}
              {tab === "Relatórios" && <RelatorioTabs />}
              {tab === "Ranking" && <Ranking />}
              {tab === "Taxa" && <TaxaPlataforma />}
              {tab === "Mensagens" && <Mensagens />}
              {tab === "Alertas" && <Alertas />}
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Admin;